import React, { useCallback, useEffect, useState } from "react";
import { pagosApi } from "./pagosApi";

const fecha = (valor) => String(valor || "").slice(0, 10);

export default function CatalogoListas({ token }) {
  const [estado, setEstado] = useState(null);
  const [archivo, setArchivo] = useState(null);
  const [vigenteDesde, setVigenteDesde] = useState("");
  const [detalle, setDetalle] = useState(null);
  const [confirmado, setConfirmado] = useState(false);
  const [comentario, setComentario] = useState("");
  const [error, setError] = useState("");
  const [aviso, setAviso] = useState("");
  const [cargando, setCargando] = useState(false);

  const cargar = useCallback(async () => {
    setError("");
    try { setEstado(await pagosApi.listasEstado(token)); }
    catch (e) { setError(e?.message || "No se pudo consultar el catálogo de Listas."); }
  }, [token]);

  useEffect(() => { cargar(); }, [cargar]);

  const ejecutar = async (accion, mensaje) => {
    setCargando(true); setError(""); setAviso("");
    try { await accion(); setAviso(mensaje); setDetalle(null); setComentario(""); setConfirmado(false); await cargar(); }
    catch (e) { setError(e?.message || "No se pudo completar la operación."); }
    finally { setCargando(false); }
  };

  const importar = () => ejecutar(async () => {
    if (!archivo || !vigenteDesde) throw new Error("Seleccioná el Diario y la fecha desde la que rige.");
    const version = await pagosApi.listasImportar({ archivo, vigenteDesde }, token);
    setArchivo(null);
    setDetalle(await pagosApi.listasDetalle(version.id, token));
  }, "La versión quedó pendiente de revisión; todavía no se usa en cálculos.");

  if (!estado && !error) return <section className="pagos-panel"><p>Cargando catálogo de Listas…</p></section>;
  return <section className="pagos-panel" data-testid="catalogo-listas">
    <div className="pagos-section-heading"><div><h2>Condiciones financieras de Listas</h2>
      <p>La versión activa se elige automáticamente por fecha. Importá otra sólo cuando cambien las condiciones.</p></div>
      {estado?.vigenteHoy && <span className="pagos-status pagos-status--ok">Vigente desde {fecha(estado.vigenteHoy.vigenteDesde)}</span>}
    </div>
    {error && <div className="pagos-alert pagos-alert--error" role="alert">{error}</div>}
    {aviso && <div className="pagos-alert pagos-alert--success" role="status">{aviso}</div>}
    {estado && !estado.habilitado && <div className="pagos-alert pagos-alert--warning">{estado.motivo}</div>}
    {estado?.habilitado && <>
      {!estado.puedeEscribir && <div className="pagos-alert pagos-alert--warning">Catálogo en sólo lectura: {estado.problemaPermisos}</div>}
      <div className="pagos-guide-inputs">
        <label className="pagos-date"><span>Nueva hoja Listas</span><input aria-label="Nueva hoja Listas" type="file" accept=".xlsm,.xlsx" onChange={(e) => setArchivo(e.target.files?.[0] || null)} /></label>
        <label className="pagos-date"><span>Vigente desde</span><input aria-label="Vigente desde" type="date" value={vigenteDesde} onChange={(e) => setVigenteDesde(e.target.value)} /></label>
        <button type="button" className="pagos-secondary" disabled={cargando || !estado.puedeEscribir || !archivo || !vigenteDesde} onClick={importar}>Importar para revisión</button>
      </div>
      <p className="pagos-cell-note">Importar no activa ni reemplaza nada. El archivo se reduce a las condiciones que usa el motor; comercios, terminales, CUIT, legajos y cuentas siguen saliendo del CRM.</p>
      <div className="pagos-table-wrap"><table aria-label="Versiones de Listas"><thead><tr><th>Vigencia</th><th>Archivo</th><th>Estado</th><th>Cambios</th><th>Auditoría</th><th /></tr></thead><tbody>
        {(estado.versiones || []).map((v) => <tr key={v.id}><td>{fecha(v.vigenteDesde)}</td><td>{v.archivo}<small className="pagos-cell-note">{String(v.sha256 || "").slice(0, 12)}…</small></td>
          <td>{String(v.estado || "").replaceAll("_", " ")}</td><td>{v.altas} altas · {v.bajas} bajas · {v.modificaciones} modificaciones{v.cambiosSensibles ? ` · ${v.cambiosSensibles} sensibles` : ""}</td>
          <td>{v.cargadoPor} · {fecha(v.cargadoEn)}{v.revisadoPor ? <small className="pagos-cell-note">Revisó {v.revisadoPor} · {fecha(v.revisadoEn)}</small> : null}</td>
          <td><button type="button" className="pagos-secondary" onClick={async () => { setError(""); try { setDetalle(await pagosApi.listasDetalle(v.id, token)); } catch (e) { setError(e?.message); } }}>Revisar</button></td></tr>)}
      </tbody></table></div>
    </>}
    {detalle && <div className="pagos-panel"><h3>Revisión: {detalle.version.archivo}</h3>
      <p>{detalle.cambios.length} cambios; {detalle.version.cambiosSensibles} sensibles.</p>
      <div className="pagos-table-wrap"><table aria-label="Cambios de Listas"><thead><tr><th>Sección</th><th>Clave</th><th>Tipo</th><th>Detalle</th></tr></thead><tbody>
        {detalle.cambios.map((c, i) => <tr key={`${c.seccion}-${c.clave}-${i}`} className={c.sensible ? "pagos-row--review" : ""}><td>{c.seccion}</td><td>{c.clave}</td><td>{c.tipo}{c.sensible ? " · SENSIBLE" : ""}</td><td>{c.descripcion}</td></tr>)}
      </tbody></table></div>
      {detalle.version.estado === "PENDIENTE_REVISION" && <>
        {detalle.version.cambiosSensibles > 0 && <label><input type="checkbox" checked={confirmado} onChange={(e) => setConfirmado(e.target.checked)} /> Confirmo que revisé los cambios sensibles de CUIT/titular.</label>}
        <label className="pagos-date"><span>Comentario de revisión</span><input value={comentario} onChange={(e) => setComentario(e.target.value)} /></label>
        <div className="pagos-final-actions"><button type="button" className="pagos-primary" disabled={cargando || (detalle.version.cambiosSensibles > 0 && !confirmado)} onClick={() => ejecutar(
          () => pagosApi.listasActivar(detalle.version.id, { confirmoCambiosSensibles: confirmado, comentario }, token), "Versión activada desde su fecha de vigencia.")}>Activar</button>
          <button type="button" className="pagos-secondary" disabled={cargando || !comentario.trim()} onClick={() => ejecutar(
            () => pagosApi.listasRechazar(detalle.version.id, comentario, token), "Versión rechazada; no se usará en cálculos.")}>Rechazar</button></div>
      </>}
    </div>}
  </section>;
}
